/**
 * If a fetch request takes too long, throw an error.
 *
 * @author Taken from https://stackoverflow.com/a/49857905
 * @author This can be improved on https://stackoverflow.com/questions/31061838/how-do-i-cancel-an-http-fetch-request/47250621#47250621
 * @param request Your request object.
 * @param timeout Time in milliseconds until timeout.
 */
import { NetworkError } from "../Errors/NetworkError";
export default function (request, timeout = 7000) {
    return Promise.race([
        window.fetch(request),
        new Promise((_, reject) => setTimeout(() => reject(new NetworkError('timeout')), timeout))
    ]);
}
